import React from "react";
import { useSelector } from "react-redux";

import Modal from "react-bootstrap/Modal";

import CloseButtonComponent from "../closeButton";
import { StyledModal } from "./styledModal";

const ModalComponent = ({ children, header, ...props }) => {
  const alertState = useSelector((state) => state.alert);

  return (
    <StyledModal
      centered={!alertState.backdrop && !alertState.notCentered}
      backdropClassName={!alertState.backdrop && "opacity-0"}
      $maxWidth={alertState.maxWidth}
      $shadow={!alertState.backdrop}
      {...props}
    >
      {header ? (
        <Modal.Header className="border-0">
          <Modal.Title>{header}</Modal.Title>
          <CloseButtonComponent
            closeFunction={props.onHide}
            className="modal-close-button"
          />
        </Modal.Header>
      ) : (
        <></>
      )}
      <Modal.Body>{children}</Modal.Body>
    </StyledModal>
  );
};

export default ModalComponent;
